import { ReactComponent as StarIcon } from 'assets/images/tristar.svg';

import YesIcon from 'assets/images/yes-icon.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.svg';
import Theme from 'theme';
import CustomTheme from 'customTheme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  // SYNC-only portal: every non-/appointments route redirects to the booking flow.
  onlySYNC: true,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Pearl Dental',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'pearlcaresSubscriberToken',
  globalClass: 'pearlcares-container',
  clientHeader,
  pricingType: 'standard-pricing',
  enableHeroButton: true,
  enableBookAppointment: true,
  headerProps: {
    enable: false,
  },
  homeTemplateProps: {
    heroSection: {
      variant: 1,
      preTitle: <StarIcon />,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      secondaryButton: 'Login',
      secondaryButtonProps: {
        to: '/login',
      },
      heroImage: '/images/home-images/home-banner-img.webp',
      verticalAlignImage: 'bottom',
    },
    benefitsSection: {
      variant: 3,
      columns: 2,
      heroImage: '/images/home-images/benefits.webp',
      preTitle: <StarIcon />,
      alignCard: 'left',
    },
    subscriptionSection: {
      tabVariant: 2,
      carouselResponsiveItems: {
        desktop: 3,
      },
      showAddons: false,
    },
    howItWorksSection: {
      variant: 2,
      alignTitle: 'left',
      preTitle: <StarIcon />,
      heroImage: '/images/home-images/how-it-works.webp',
    },
    testimonialSection: {},
    staticHeroSection: {
      enable: true,
      variant: 1,
    },
  },
  checkoutSection: {
    preTitle: <StarIcon />,
  },
  findProviderSection: {
    preTitle: <StarIcon />,
    iconProps: {
      url: '/images/map-loc-icon.svg',
      width: 32,
      height: 32,
    },
  },
  choosePlanSection: {
    preTitle: <StarIcon />,
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 2,
    tabVariant: 2,
    tabLabel: {
      annual: 'Billed Annually',
      annual_billed_monthly: 'Billed Monthly',
    },
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'outlined',
        highlightedVariant: 'contained',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      title: 'Frequently asked questions',
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
  },
  bookAppointmentV2: {
    theme: CustomTheme,
    rightImage: '/images/home-images/appointment-right.webp',
    skipPatientTypeSelection: true,
    flowV2: true,
    headerProps: {
      enable: false,
    },
    previousStepButton: {
      enable: true,
    },
    searchFieldVariant: 2,
    highlightSelectedCardTitle: false,
  },
  savingsSummary: {
    heroPreTitle: <StarIcon />,
    enableFooterbar: true,
    contactSection: 'contactDetails',
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
    moreSavingsButtonProps: {
      variant: 'outlined',
      color: 'primary',
    },
  },
  faqSection: {
    heroPreTitle: <StarIcon />,
  },
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  footer: {
    enable: false,
  },
  loginPage: {
    preTitle: <StarIcon />,
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
